"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.277975 2.72222C5.56647 2.72222 8.96265 0.907678 9.99997 0.000202756V0L10.0001 0.000101259L10.0002 0V0.000202756C11.0375 0.907678 14.4337 2.72222 19.7222 2.72222C19.8518 7.90736 18.0889 18.822 10.0002 20.9999V21L10.0001 21L9.99997 21V20.9999C1.91128 18.822 0.148347 7.90736 0.277975 2.72222ZM13.8888 9.33333V8.55556C13.8888 6.40778 12.1477 4.66667 9.99995 4.66667C7.85217 4.66667 6.11106 6.40778 6.11106 8.55556V9.33333L5.3335 9.33333V13.3333C5.3335 14.9902 6.67664 16.3333 8.3335 16.3333H11.6668C13.3237 16.3333 14.6668 14.9902 14.6668 13.3333V9.33333H13.8888ZM12.7222 9.33333L7.27772 9.33333V8.55556C7.27772 7.05211 8.4965 5.83333 9.99995 5.83333C11.5034 5.83333 12.7222 7.05211 12.7222 8.55556V9.33333ZM8.83333 14.3889L9.53329 12.289C9.34431 12.1471 9.22206 11.9212 9.22206 11.6667C9.22206 11.2371 9.57028 10.8889 9.99984 10.8889H10C10.4295 10.889 10.7776 11.2372 10.7776 11.6667C10.7776 11.9211 10.6555 12.1469 10.4666 12.2888L11.1667 14.3889H8.83333Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;